/**
 * Google Analytics 4 — set REACT_APP_GA_MEASUREMENT_ID in Netlify env (e.g. G-XXXXXXXXXX).
 */
export function initAnalytics() {
  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (gaId && gaId !== "G-XXXXXXXXXX") {
    initGa(gaId);
  }
  const pixelId = process.env.REACT_APP_FB_PIXEL_ID;
  if (pixelId && pixelId !== "YOUR_PIXEL_ID") {
    initFacebookPixel(pixelId);
  }
}

function initGa(gaId) {
  if (window.__typogramGaInitialized) {
    return;
  }
  window.__typogramGaInitialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", gaId, {
    send_page_view: false,
  });
}

function initFacebookPixel(pixelId) {
  if (window.__typogramFbInitialized || typeof window.fbq === "function") {
    return;
  }
  window.__typogramFbInitialized = true;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
}

export function trackPageView(path) {
  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!gaId || gaId === "G-XXXXXXXXXX" || typeof window.gtag !== "function") {
    return;
  }
  window.gtag("config", gaId, {
    page_path: path,
  });
}
